import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { store, persistor } from "./app/store";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Intercept HTMLMediaElement.prototype.play to gracefully handle interruptions when media elements are detached
if (typeof window !== "undefined" && window.HTMLMediaElement) {
  const originalPlay = window.HTMLMediaElement.prototype.play;
  window.HTMLMediaElement.prototype.play = function (...args) {
    const playPromise = originalPlay.apply(this, args);
    if (playPromise && typeof playPromise.catch === "function") {
      return playPromise.catch((err) => {
        if (
          err &&
          (err.name === "AbortError" ||
            err.name === "NotSupportedError" ||
            (err.message &&
              err.message.toLowerCase().includes("play() request was interrupted")))
        ) {
          // Benign error caused by element being removed while video was loading
          return;
        }
        return Promise.reject(err);
      });
    }
    return playPromise;
  };

  // Add capturing unhandledrejection & error listeners so CRA error overlay never catches it
  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const msg =
        event?.reason?.message ||
        (typeof event?.reason === "string" ? event.reason : "") ||
        "";
      const name = event?.reason?.name || "";
      if (
        name === "AbortError" ||
        msg.toLowerCase().includes("play() request was interrupted") ||
        msg.toLowerCase().includes("media was removed from the document")
      ) {
        event.preventDefault();
        event.stopImmediatePropagation?.();
      }
    },
    true
  );

  window.addEventListener(
    "error",
    (event) => {
      const msg = event?.message || "";
      if (
        msg.toLowerCase().includes("play() request was interrupted") ||
        msg.toLowerCase().includes("media was removed from the document")
      ) {
        event.preventDefault();
        event.stopImmediatePropagation?.();
      }
    },
    true
  );
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.register();
